<template>
  <div>
    <div class="mb-3">
      <li
        style="
          text-align: start;
          display: block;
          color: #000000;
          font-family: dfyuanstd-w5, dfyuanstd-w3;
          font-size: 1rem;
        "
      >
        使用線材
      </li>
      <wireTable
        :wireItem="
          orderManagementDetailData.sourceData[userSelectCode].wireItem
        "
        :reason="orderManagementDetailData.sourceData[userSelectCode].reason"
        :modStatus="modStatus"
      />
    </div>
    <div class="mb-3">
      <li
        style="
          text-align: start;
          display: block;
          color: #000000;
          font-family: dfyuanstd-w5, dfyuanstd-w3;
          font-size: 1rem;
        "
      >
        生產重量
      </li>
      <div class="d-flex justify-content-start" style="margin-bottom: 4px">
        <span class="my-auto">單支重(G)：</span>
        <input
          type="number"
          min="0"
          step="0.01"
          @blur="checkChangeInput('unit_actual_weight')"
          v-model="
            orderManagementDetailData.sourceData[userSelectCode]
              .unit_actual_weight
          "
          :disabled="!modStatus"
          class="text-center"
          :class="{
            'sourceRecord-input-disabled': !modStatus,
          }"
          style="width: 75px"
          name="unitActualWeight"
        />
      </div>
      <runcardTable
        :workID="orderManagementDetailData.workCode"
        :runcardItem="
          orderManagementDetailData.sourceData[userSelectCode].runcardItem
        "
        :reason="orderManagementDetailData.sourceData[userSelectCode].reason"
        :modStatus="modStatus"
      />
    </div>
    <div class="mb-3">
      <li
        style="
          text-align: start;
          display: block;
          color: #000000;
          font-family: dfyuanstd-w5, dfyuanstd-w3;
          font-size: 1rem;
        "
      >
        總生產時間
      </li>
      <totalProduceTable
        :processID="orderManagementDetailData.operID"
        :totalProduceTimeItem="
          orderManagementDetailData.sourceData[userSelectCode]
            .totalProduceTimeItem
        "
        :reason="orderManagementDetailData.sourceData[userSelectCode].reason"
        :modStatus="modStatus"
      />
    </div>
  </div>
</template>

<script>
import wireTable from "@/components/orderManagement/orderDataTemplate/table/wireTable.vue";
import runcardTable from "@/components/orderManagement/orderDataTemplate/table/runcardTable.vue";
import totalProduceTable from "@/components/orderManagement/orderDataTemplate/table/totalProduceTable.vue";
import { inject } from "vue";
import { useStore } from "vuex";
export default {
  props: {
    userSelectCode: {
      type: Number,
      default: 0,
    },
    modStatus: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    wireTable,
    runcardTable,
    totalProduceTable,
  },
  setup(props) {
    const store = useStore();

    //dispatch
    const methods = {
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const orderManagementDetailData = inject("orderManagementDetailData");

    const checkChangeInput = (position, index = null) => {
      console.log(props.userSelectCode, orderManagementDetailData);
      switch (position) {
        case "unit_actual_weight":
          console.log("unit_actual_weight");
          let unit_actual_weight =
            orderManagementDetailData.value.sourceData[props.userSelectCode]
              .unit_actual_weight;
          if (
            unit_actual_weight < 0 ||
            unit_actual_weight == "" ||
            isNaN(unit_actual_weight)
          ) {
            orderManagementDetailData.value.sourceData[
              props.userSelectCode
            ].unit_actual_weight =
              orderManagementDetailData.value.sourceData[
                props.userSelectCode
              ].orgUnit_actual_weight;
            methods.setTimeoutAlert(`單支重僅能是正數，請再次確認`);
            return;
          }

          let std_sgl_weight =
            orderManagementDetailData.value.sourceData[props.userSelectCode]
              .std_sgl_weight;
          let unit_range = [
            Number((std_sgl_weight * 0.9).toFixed(2)),
            Number((std_sgl_weight * 1.1).toFixed(2)),
          ];
          console.log(unit_range);
          if (
            unit_range[0] > unit_actual_weight ||
            unit_actual_weight > unit_range[1]
          ) {
            orderManagementDetailData.value.sourceData[
              props.userSelectCode
            ].unit_actual_weight =
              orderManagementDetailData.value.sourceData[
                props.userSelectCode
              ].orgUnit_actual_weight;
            methods.setTimeoutAlert(
              `單支重須符合標準重量:${unit_range[0]}~${unit_range[1]}，請再次確認`
            );
            return;
          }

          orderManagementDetailData.value.sourceData[
            props.userSelectCode
          ].orgUnit_actual_weight = unit_actual_weight;
          var queryIndex =
            orderManagementDetailData.value.sourceData[
              props.userSelectCode
            ].reason.indexOf("unit_actual_weight");
          if (
            orderManagementDetailData.value.sourceData[props.userSelectCode]
              .in_unit_actual_weight != unit_actual_weight
          ) {
            if (queryIndex == -1) {
              orderManagementDetailData.value.sourceData[
                props.userSelectCode
              ].reason.push("unit_actual_weight");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              orderManagementDetailData.value.sourceData[
                props.userSelectCode
              ].reason.splice(queryIndex, 1);
            }
          }
          break;

        default:
          break;
      }
    };

    return {
      orderManagementDetailData,
      checkChangeInput,
    };
  },
};
</script>

<style scoped></style>